export var ItemTypes = {
  DRAGGABLE: 'Draggable'
};